<template>
  <div class="flex-1 mx-auto flex flex-col">
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
      <div class="mt-8">
        <!-- Activity list (smallest breakopoint only) -->
        <div class="shadow sm:hidden">
          <ul
            class="mt-2 divide-y divide-gray-200 overflow-hidden shadow sm:hidden"
          >
            <li v-for="member in members" v-bind:key="'mobile-' + member.id">
              <div class="block px-2 py-2 bg-white hover:bg-gray-50">
                <span class="flex items-center space-x-4">
                  <span class="flex-1 flex space-x-2 truncate">
                    <div class="flex-1 px-3 py-1 whitespace-nowrap">
                      <div class="flex items-center">
                        <AccountIcon :initials="member.name | initials" />
                        <div class="ml-4">
                          <div class="text-sm font-medium text-gray-900">
                            {{ member.name }}
                          </div>
                          <div class="text-sm text-gray-500">
                            {{ member.email }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="px-3 py-1 whitespace-nowrap flex items-center">
                      <div class="text-sm text-gray-900">
                        {{
                          member.created_at | displayLocalDateTime("MM/DD/YY")
                        }}
                      </div>
                    </div>
                    <div class="px-3 py-1 whitespace-nowrap flex items-center">
                      <span
                        class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                      >
                        Active
                      </span>
                    </div>
                  </span>
                </span>
              </div>
            </li>
          </ul>
        </div>

        <!-- Activity table (small breakopoint and up) -->
        <div class="hidden sm:block">
          <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex flex-col mt-2">
              <div
                class="shadow overflow-auto border-b border-gray-200 sm:rounded-lg"
              >
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Member Since
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Role
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr
                      v-for="member in members"
                      v-bind:key="'dtop-' + member.id"
                    >
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="flex items-center">
                          <AccountIcon :initials="member.name | initials" />
                          <div class="ml-4">
                            <div class="text-sm font-medium text-gray-900">
                              {{ member.name }}
                            </div>
                            <div class="text-sm text-gray-500">
                              {{ member.email }}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <div class="text-sm text-gray-900">
                          {{
                            member.created_at | displayLocalDateTime("MM/DD/YY")
                          }}
                        </div>
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap">
                        <span
                          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                        >
                          Active
                        </span>
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {{ member.role | displayRole }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import * as Config from "@/config";
import { mapGetters } from "vuex";
import CustomTable from "@/components/general/CustomTable";
import AccountIcon from "@/components/AccountIcon";

export default {
  name: "MediaNetworkMembers",
  data() {
    return {
      members: [],
      polling: true
    };
  },
  mounted() {
    this.getMembers();
  },
  components: { CustomTable, AccountIcon },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    async getMembers() {
      try {
        var res = await this.$http
          .get(
            Config.apiPath + "/api/v2/media/members",
            this.getAuthorizationHeader()
          )
          this.members = res.data
        } catch (e) {}
        this.polling = false
    }
  }
};
</script>
